module.exports = __webpack_public_path__ + "img/Mills_SuperOK-66.db7b58ea.jpg";